import { AllLeaguesScreenContent } from '@/components/league-navigator/screens/AllLeaguesScreen';

import { usePickemAllLeagues } from '../hooks/use-pickem-all-leagues';

export const PickemAllLeaguesScreen = () => {
    const { sections, isLoading, onSelectLeague } = usePickemAllLeagues();
    return (
        <AllLeaguesScreenContent
            sections={sections}
            status={isLoading ? 'loading' : 'ready'}
            onSelectLeague={onSelectLeague}
        />
    );
};
